import { Currency } from '@shared/helpers/currency';
import { UserPbxPackage } from './user-pbx-package';

const SMS_V3_DATE = '2023-03-03 00:00:00';

export class User {
  constructor(data = {}) {
    this.id = data.id || null;
    this.created_at = data.created_at || null;
    this.role = data.role || null;
    this.name = data.name || null;
    this.company = data.company || null;
    this.phone = data.phone || null;
    this.email = data.email || null;
    this.timezone = data.timezone || null;
    this.balance = data.balance || null;
    this.ref_code = data.ref_code || null;
    this.email_confirmed = !!data.email_confirmed;
    this.token = data.token || null;
    this.user_key = data.user_key || null;
    this.currency = data.currency || null;
    this.locale = data.locale || null;
    this.pbx = new UserPbxPackage(data.pbx || {});
    this.payment = data.payment || {};
    this.rates = data.rates || [];
    this.finance_email = data.finance_email ? data.finance_email.split(',') : [];
    this.email_rates = data.email_rates ? data.email_rates.split(',') : [];
    this.sms_stats_from_new_module_allowed = data.created_at
      ? new Date(data.created_at).getTime() >= new Date(SMS_V3_DATE).getTime()
      : false;
  }

  static isValidObject = function (user = {}) {
    const is_required_fields_exist = ['id', 'name', 'currency'].every((key) => key in user);
    const is_valid_id = user.id > 0;
    const is_valid_currency = Currency.isAllowed(user.currency);
    const not_admin = user.role !== 'admin';
    const rules = [is_required_fields_exist, is_valid_id, is_valid_currency, not_admin];

    return rules.every((item) => item === true);
  };

  get available_rates() {
    return this.rates.map((item) => item.type);
  }
}
